import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  id: "kn-parameter-sidebar-toolbar-icons-container",
  class: "p-d-flex p-flex-row p-jc-around"
}
const _hoisted_2 = { class: "p-fluid kn-parameter-sidebar-content kn-alternated-rows" }
const _hoisted_3 = {
  key: 0,
  class: "p-field p-my-1 p-p-2"
}
const _hoisted_4 = { class: "p-d-flex" }
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = { class: "p-field p-m-4" }
const _hoisted_7 = { class: "p-d-flex" }
const _hoisted_8 = { class: "kn-material-input-label" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  id: "chips-help"
}
const _hoisted_11 = {
  key: 0,
  class: "p-field p-my-1 p-p-2"
}
const _hoisted_12 = { class: "p-d-flex" }
const _hoisted_13 = {
  key: 1,
  class: "p-field p-my-1 p-p-2"
}
const _hoisted_14 = { class: "p-d-flex" }
const _hoisted_15 = {
  key: 2,
  class: "p-field p-my-1 p-p-2"
}
const _hoisted_16 = { class: "p-d-flex" }
const _hoisted_17 = {
  key: 3,
  class: "p-field p-my-1 p-p-2"
}
const _hoisted_18 = { class: "p-d-flex" }
const _hoisted_19 = {
  key: 4,
  class: "p-field p-my-1 p-p-2"
}
const _hoisted_20 = { class: "p-d-flex" }
const _hoisted_21 = { class: "p-d-flex p-flex-row" }
const _hoisted_22 = {
  key: 5,
  class: "p-field p-my-1 p-p-2"
}
const _hoisted_23 = { class: "p-d-flex" }
const _hoisted_24 = { class: "p-d-flex p-flex-row" }
const _hoisted_25 = {
  key: 1,
  class: "p-fluid p-d-flex p-flex-row p-m-2 kn-parameter-sidebar-buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Chips = _resolveComponent("Chips")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Chip = _resolveComponent("Chip")
  const _component_Menu = _resolveComponent("Menu")
  const _component_KnParameterPopupDialog = _resolveComponent("KnParameterPopupDialog")
  const _component_KnParameterTreeDialog = _resolveComponent("KnParameterTreeDialog")
  const _component_KnParameterSaveDialog = _resolveComponent("KnParameterSaveDialog")
  const _component_KnParameterSavedParametersDialog = _resolveComponent("KnParameterSavedParametersDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", {
    id: "kn-parameter-sidebar",
    class: _ctx.positionClass
  }, [
    (_ctx.mode !== 'workspaceView' && _ctx.mode !== 'qbeView' && _ctx.mode !== 'datasetManagement')
      ? (_openBlock(), _createBlock(_component_Toolbar, {
          key: 0,
          id: "kn-parameter-sidebar-toolbar",
          class: "kn-toolbar kn-toolbar--secondary"
        }, {
          start: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _withDirectives(_createVNode(_component_Button, {
                icon: "fa fa-eraser",
                class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                onClick: _ctx.resetAllParameters
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('documentExecution.main.resetParametersTooltip'),
                  void 0,
                  { top: true }
                ]
              ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-pencil",
                class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                onClick: _ctx.openSavedParametersDialog
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('documentExecution.main.savedParametersTooltip'),
                  void 0,
                  { top: true }
                ]
              ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "fas fa-save",
                class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                onClick: _ctx.openSaveParameterDialog
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('documentExecution.main.saveParametersFromStateTooltip'),
                  void 0,
                  { top: true }
                ]
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      (_ctx.user && (!_ctx.sessionRole || _ctx.sessionRole === _ctx.$t('role.defaultRolePlaceholder')) && (_ctx.mode === 'execution' || _ctx.mode === 'qbeView' || (_ctx.mode === 'workspaceView' && _ctx.dataset?.drivers?.length > 0)) && _ctx.availableRolesForExecution.length > 1)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.roles')), 1)
            ]),
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.role,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.role = $event)),
              options: _ctx.availableRolesForExecution,
              onChange: _ctx.setNewSessionRole
            }, null, 8, ["modelValue", "options", "onChange"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mode === 'qbeView' || _ctx.mode === 'workspaceView' || _ctx.mode === 'datasetManagement')
        ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.qbeParameters, (qbeParameter, index) => {
            return (_openBlock(), _createBlock("div", { key: index }, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("label", _hoisted_8, [
                    _createTextVNode(_toDisplayString(qbeParameter.name) + " ", 1),
                    (_ctx.mode !== 'datasetManagement')
                      ? (_openBlock(), _createBlock("span", _hoisted_9, " *"))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createVNode("i", {
                    class: "fa fa-eraser parameter-clear-icon kn-cursor-pointer",
                    onClick: ($event: any) => (qbeParameter.value = qbeParameter.defaultValue)
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.parameterClearTooltip'),
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                (qbeParameter.multiValue)
                  ? (_openBlock(), _createBlock(_component_Chips, {
                      key: 0,
                      modelValue: qbeParameter.value,
                      "onUpdate:modelValue": ($event: any) => (qbeParameter.value = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (qbeParameter.multiValue)
                  ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.$t('common.chipsHint')), 1))
                  : (_openBlock(), _createBlock(_component_InputText, {
                      key: 2,
                      class: ["kn-material-input p-inputtext-sm", {
                                'p-invalid': !qbeParameter.value && _ctx.mode !== 'datasetManagement'
                            }],
                      modelValue: qbeParameter.value,
                      "onUpdate:modelValue": ($event: any) => (qbeParameter.value = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]))
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.parameters.filterStatus, (parameter, index) => {
        return (_openBlock(), _createBlock(_Fragment, { key: index }, [
          ((parameter.type === 'STRING' || parameter.type === 'NUM') && !parameter.selectionType && parameter.valueSelection === 'man_in' && parameter.showOnPanel === 'true' && parameter.visible)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("label", {
                    class: ["kn-material-input-label", {
                                'p-text-italic': parameter.dependsOnParameters || parameter.lovDependsOnParameters
                            }],
                    "data-test": 'parameter-input-label-' + parameter.id
                  }, _toDisplayString(parameter.label) + " " + _toDisplayString(parameter.mandatory ? '*' : ''), 11, ["data-test"]),
                  _withDirectives(_createVNode("i", {
                    class: "fa fa-eraser parameter-clear-icon kn-cursor-pointer",
                    onClick: ($event: any) => (_ctx.resetParameterValue(parameter)),
                    "data-test": 'parameter-input-clear-' + parameter.id
                  }, null, 8, ["onClick", "data-test"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.parameterClearTooltip'),
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                (parameter.parameterValue && parameter.parameterValue[0])
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      class: ["kn-material-input p-inputtext-sm", {
                            'p-invalid': parameter.mandatory && parameter.parameterValue && !parameter.parameterValue[0]?.value
                        }],
                      type: parameter.type === 'NUM' ? 'number' : 'text',
                      modelValue: parameter.parameterValue[0].value,
                      "onUpdate:modelValue": ($event: any) => (parameter.parameterValue[0].value = $event),
                      onBlur: ($event: any) => (_ctx.onInputTextChanged(parameter)),
                      onKeypress: _withKeys(($event: any) => (_ctx.onInputTextChanged(parameter)), ["enter"]),
                      "data-test": 'parameter-input-' + parameter.id
                    }, null, 8, ["type", "modelValue", "onUpdate:modelValue", "class", "onBlur", "onKeypress", "data-test"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (parameter.type === 'DATE' && !parameter.selectionType && parameter.valueSelection === 'man_in' && parameter.showOnPanel === 'true' && parameter.visible)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("label", {
                    class: ["kn-material-input-label", {
                                'p-text-italic': parameter.dependsOnParameters || parameter.lovDependsOnParameters
                            }],
                    "data-test": 'parameter-date-label-' + parameter.id
                  }, _toDisplayString(parameter.label) + " " + _toDisplayString(parameter.mandatory ? '*' : ''), 11, ["data-test"]),
                  _withDirectives(_createVNode("i", {
                    class: "fa fa-eraser parameter-clear-icon kn-cursor-pointer",
                    onClick: ($event: any) => (_ctx.resetParameterValue(parameter)),
                    "data-test": 'parameter-date-clear-' + parameter.id
                  }, null, 8, ["onClick", "data-test"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.parameterClearTooltip'),
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                (parameter.parameterValue)
                  ? (_openBlock(), _createBlock(_component_Calendar, {
                      key: 0,
                      modelValue: parameter.parameterValue[0].value,
                      "onUpdate:modelValue": ($event: any) => (parameter.parameterValue[0].value = $event),
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: true,
                      class: ["kn-material-input custom-timepicker", {
                            'p-invalid': parameter.mandatory && parameter.parameterValue && !parameter.parameterValue[0]?.value
                        }],
                      maxDate: parameter.driverMaxDateValue ?? undefined,
                      onChange: ($event: any) => (_ctx.updateDependency(parameter)),
                      onDateSelect: ($event: any) => (_ctx.updateDependency(parameter)),
                      "data-test": 'parameter-date-input-' + parameter.id
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "maxDate", "onChange", "onDateSelect", "data-test"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (parameter.selectionType === 'LIST' && parameter.showOnPanel === 'true' && parameter.visible)
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("label", {
                    class: ["kn-material-input-label", {
                                'kn-required-alert': parameter.mandatory && ((!parameter.multivalue && parameter.parameterValue && !parameter.parameterValue[0]?.value) || (parameter.multivalue && parameter.parameterValue && parameter.parameterValue.length === 0)),
                                'p-text-italic': parameter.dependsOnParameters || parameter.lovDependsOnParameters
                            }],
                    "data-test": 'parameter-checkbox-label-' + parameter.id
                  }, _toDisplayString(parameter.label) + " " + _toDisplayString(parameter.mandatory ? '*' : ''), 11, ["data-test"]),
                  _withDirectives(_createVNode("i", {
                    class: "fa fa-eraser parameter-clear-icon kn-cursor-pointer",
                    onClick: ($event: any) => (_ctx.resetParameterValue(parameter)),
                    "data-test": 'parameter-checkbox-clear-' + parameter.id
                  }, null, 8, ["onClick", "data-test"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.parameterClearTooltip'),
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                _createVNode(_component_ScrollPanel, { class: "inputScrollPanel" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(parameter.data, (option, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "p-field-radiobutton",
                        key: index,
                        "data-test": 'parameter-list-' + parameter.id
                      }, [
                        (!parameter.multivalue && parameter.parameterValue)
                          ? (_openBlock(), _createBlock(_component_RadioButton, {
                              key: 0,
                              value: option.value,
                              modelValue: parameter.parameterValue[0].value,
                              "onUpdate:modelValue": ($event: any) => (parameter.parameterValue[0].value = $event),
                              onChange: ($event: any) => (_ctx.setRadioButtonValue(parameter))
                            }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "onChange"]))
                          : _createCommentVNode("", true),
                        (parameter.multivalue && parameter.parameterValue)
                          ? (_openBlock(), _createBlock(_component_Checkbox, {
                              key: 1,
                              value: option.value,
                              modelValue: _ctx.selectedParameterCheckbox[parameter.id],
                              "onUpdate:modelValue": ($event: any) => (_ctx.selectedParameterCheckbox[parameter.id] = $event),
                              onChange: ($event: any) => (_ctx.setCheckboxValue(parameter))
                            }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "onChange"]))
                          : _createCommentVNode("", true),
                        _createVNode("label", null, _toDisplayString(option.description), 1)
                      ], 8, ["data-test"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true),
          (parameter.selectionType === 'COMBOBOX' && parameter.showOnPanel === 'true' && parameter.visible)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("label", {
                    class: ["kn-material-input-label", {
                                'kn-required-alert': parameter.mandatory && ((!parameter.multivalue && parameter.parameterValue && !parameter.parameterValue[0]?.value) || (parameter.multivalue && parameter.parameterValue?.length === 0)),
                                'p-text-italic': parameter.dependsOnParameters || parameter.lovDependsOnParameters
                            }]
                  }, _toDisplayString(parameter.label) + " " + _toDisplayString(parameter.mandatory ? '*' : ''), 3),
                  _withDirectives(_createVNode("i", {
                    class: "fa fa-eraser parameter-clear-icon kn-cursor-pointer",
                    onClick: ($event: any) => (_ctx.resetParameterValue(parameter))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.parameterClearTooltip'),
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                (!parameter.multivalue && parameter.parameterValue[0])
                  ? (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 0,
                      class: "kn-material-input",
                      modelValue: parameter.parameterValue[0].value,
                      "onUpdate:modelValue": ($event: any) => (parameter.parameterValue[0].value = $event),
                      options: parameter.data,
                      optionValue: "value",
                      optionLabel: "description",
                      onChange: ($event: any) => (_ctx.onDropdownChange(parameter))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]))
                  : (_openBlock(), _createBlock(_component_MultiSelect, {
                      key: 1,
                      modelValue: parameter.parameterValue,
                      "onUpdate:modelValue": ($event: any) => (parameter.parameterValue = $event),
                      options: parameter.data,
                      optionLabel: "description",
                      onChange: ($event: any) => (_ctx.updateDependency(parameter))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]))
              ]))
            : _createCommentVNode("", true),
          (parameter.selectionType === 'LOOKUP' && parameter.showOnPanel === 'true' && parameter.visible)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("label", {
                    class: ["kn-material-input-label", {
                                'kn-required-alert': parameter.mandatory && ((!parameter.multivalue && parameter.parameterValue && !parameter.parameterValue[0]?.value) || (parameter.multivalue && parameter.parameterValue?.length === 0)),
                                'p-text-italic': parameter.dependsOnParameters || parameter.lovDependsOnParameters
                            }]
                  }, _toDisplayString(parameter.label) + " " + _toDisplayString(parameter.mandatory ? '*' : ''), 3),
                  _withDirectives(_createVNode("i", {
                    class: "fa fa-eraser parameter-clear-icon kn-cursor-pointer",
                    onClick: ($event: any) => (_ctx.resetParameterValue(parameter))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.parameterClearTooltip'),
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("i", {
                    class: "pi pi-external-link kn-cursor-pointer p-mr-2",
                    onClick: ($event: any) => (_ctx.openPopupDialog(parameter))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_ScrollPanel, { class: "lookupScrollPanel" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(parameter.parameterValue, (parameterValue, index) => {
                        return (_openBlock(), _createBlock(_component_Chip, {
                          class: "parameterValueChip",
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(parameterValue.description ?? parameterValue.value), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            : _createCommentVNode("", true),
          (parameter.selectionType === 'TREE' && parameter.showOnPanel === 'true' && parameter.visible)
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _createVNode("label", {
                    class: ["kn-material-input-label", {
                                'kn-required-alert': parameter.mandatory && ((!parameter.multivalue && parameter.parameterValue && !parameter.parameterValue[0]?.value) || (parameter.multivalue && parameter.parameterValue?.length === 0)),
                                'p-text-italic': parameter.dependsOnParameters || parameter.lovDependsOnParameters
                            }]
                  }, _toDisplayString(parameter.label) + " " + _toDisplayString(parameter.mandatory ? '*' : ''), 3),
                  _withDirectives(_createVNode("i", {
                    class: "fa fa-eraser parameter-clear-icon kn-cursor-pointer",
                    onClick: ($event: any) => (_ctx.resetParameterValue(parameter))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.parameterClearTooltip'),
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("i", {
                    class: "pi pi-external-link kn-cursor-pointer p-mr-2",
                    onClick: ($event: any) => (_ctx.openTreeDialog(parameter))
                  }, null, 8, ["onClick"]),
                  _createVNode("div", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(parameter.parameterValue, (parameterValue, index) => {
                      return (_openBlock(), _createBlock(_component_Chip, { key: index }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(parameterValue.description ?? parameterValue.value), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    ((_ctx.parameters && _ctx.parameters.filterStatus.length > 0) || _ctx.mode === 'qbeView' || _ctx.mode === 'workspaceView' || _ctx.mode === 'datasetManagement')
      ? (_openBlock(), _createBlock("div", _hoisted_25, [
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary",
            disabled: _ctx.buttonsDisabled,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('execute', _ctx.qbeParameters, _ctx.parameters)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.execute')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (_ctx.mode !== 'qbeView' && _ctx.mode !== 'workspaceView' && _ctx.mode !== 'datasetManagement')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "kn-button kn-button--primary p-ml-1",
                icon: "fa fa-chevron-down",
                disabled: _ctx.buttonsDisabled,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggle($event)))
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Menu, {
            ref: "executeButtonMenu",
            model: _ctx.executeMenuItems,
            popup: true
          }, null, 8, ["model"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.popupDialogVisible)
      ? (_openBlock(), _createBlock(_component_KnParameterPopupDialog, {
          key: 2,
          visible: _ctx.popupDialogVisible,
          selectedParameter: _ctx.selectedParameter,
          propLoading: _ctx.loading,
          parameterPopUpData: _ctx.parameterPopUpData,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.popupDialogVisible = false)),
          onSave: _ctx.onPopupSave
        }, null, 8, ["visible", "selectedParameter", "propLoading", "parameterPopUpData", "onSave"]))
      : _createCommentVNode("", true),
    (_ctx.treeDialogVisible)
      ? (_openBlock(), _createBlock(_component_KnParameterTreeDialog, {
          key: 3,
          visible: _ctx.treeDialogVisible,
          selectedParameter: _ctx.selectedParameter,
          formatedParameterValues: _ctx.formatedParameterValues,
          document: _ctx.document,
          mode: _ctx.mode,
          selectedRole: _ctx.role,
          onClose: _ctx.onTreeClose,
          onSave: _ctx.onTreeSave
        }, null, 8, ["visible", "selectedParameter", "formatedParameterValues", "document", "mode", "selectedRole", "onClose", "onSave"]))
      : _createCommentVNode("", true),
    _createVNode(_component_KnParameterSaveDialog, {
      visible: _ctx.parameterSaveDialogVisible,
      propLoading: _ctx.loading,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.parameterSaveDialogVisible = false)),
      onSaveViewpoint: _ctx.saveViewpoint
    }, null, 8, ["visible", "propLoading", "onSaveViewpoint"]),
    _createVNode(_component_KnParameterSavedParametersDialog, {
      visible: _ctx.savedParametersDialogVisible,
      propViewpoints: _ctx.viewpoints,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.savedParametersDialogVisible = false)),
      onFillForm: _ctx.fillParameterForm,
      onExecuteViewpoint: _ctx.executeViewpoint,
      onDeleteViewpoint: _ctx.deleteViewpoint
    }, null, 8, ["visible", "propViewpoints", "onFillForm", "onExecuteViewpoint", "onDeleteViewpoint"])
  ], 2))
}